import { useWatch } from "react-hook-form";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";

const useHasTrust = () => {
  const hasTrust = useWatch({
    name: CPropertyValidationDocumentKeys.trust_has_trustee,
    defaultValue: []
  });

  return {
    HAS_TRUST_YES: hasTrust.some((item: any) => item.value === "yes"),
    HAS_TRUST_NO: hasTrust.some((item: any) => item.value === "no"),
    HAS_TRUST_PENDING: hasTrust.some((item: any) => item.value === "pending"),
    value: hasTrust
  };
};

export default useHasTrust;
